import { render, staticRenderFns } from "./groupChallenges.vue?vue&type=template&id=1324d82a&scoped=true&"
import script from "./groupChallenges.vue?vue&type=script&lang=js&"
export * from "./groupChallenges.vue?vue&type=script&lang=js&"
import style0 from "./groupChallenges.vue?vue&type=style&index=0&id=1324d82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324d82a",
  null
  
)

export default component.exports